import { Association } from "@entities";
import {
  createPhoneNumberFilter,
  type HyperTableFilter,
} from "@shared/frontend/hyper-table";

const filters: HyperTableFilter<Association>[] = [
  { fieldName: "user.name", id: "name" },
  createPhoneNumberFilter(Association, {
    fieldName: "user.phoneNumber",
    id: "phoneNumber",
  }),
  { fieldName: "user.address", id: "address" },
  { fieldName: "user.gender", id: "gender" },
];

export default filters;
